import { render, staticRenderFns } from "./ShowMessage.vue?vue&type=template&id=28cc2e3c&scoped=true&"
import script from "./ShowMessage.vue?vue&type=script&lang=js&"
export * from "./ShowMessage.vue?vue&type=script&lang=js&"
import style0 from "./ShowMessage.vue?vue&type=style&index=0&id=28cc2e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc2e3c",
  null
  
)

export default component.exports